import React from 'react';
import { Alert } from 'react-bootstrap';
import { WarningIcon } from './Icons';

const WbAlert = ({ children, variant }) => {
  let title, icon;

  switch (variant) {
    case 'warning':
      title = 'Warning:';
      icon = <WarningIcon />;
  }

  return (
    <Alert variant={variant} className="d-flex align-items-center py-2">
      <div className="fs-3 me-2">{icon}</div>
      <div>
        <span className="fw-bold text-uppercase">{title}</span>&nbsp;
        {children}
      </div>
    </Alert>
  );
};

export default WbAlert;
